import React from 'react'
import { Stepper, Step, StepLabel, StepConnector } from '@mui/material'
import './CustomizedStepper.sass'

const CustomStepIcon = props => {
  const { active, completed } = props

  let className = 'custom-step-icon'
  if (active) className += ' active'
  if (completed) className += ' completed'

  return (
    <div className={className}>
      <div className='step-icon-text'>{props.icon}</div>
    </div>
  )
}

const CustomizedStepper = ({ activeStep, totalSteps = 3 }) => {
  const steps = Array.from({ length: totalSteps }, (_, index) => index)

  return (
    <Stepper
      alternativeLabel
      activeStep={activeStep ?? 0}
      className='stepper-container'
      connector={<StepConnector classes={{ root: 'MuiStepConnector-root' }} />}
    >
      {steps.map(step => (
        <Step key={step}>
          <StepLabel StepIconComponent={CustomStepIcon} />
        </Step>
      ))}
    </Stepper>
  )
}

export default CustomizedStepper
